/* eslint-disable */
import {Service} from 'components/Shared/server';
import {CustomerType} from 'models/CustomerType';
import {UpdateRequest} from 'models/UpdateRequest';
import {CheckoutFormData} from 'models/CheckoutFormData';
import {PolicyInformation} from 'models/PolicyInformation';
import {CheckoutPageModel} from 'models/CheckoutPageModel';
import {AddressInfo} from 'models/AddressInfo';
import {DiscountResponse} from 'models/DiscountResponse';
import {SuggestedAddress} from 'models/SuggestedAddress';
import {AddressValidationResponse} from 'models/AddressValidationResponse';
import {PurchaseResponse} from 'models/PurchaseResponse';
import {ShareCartResponse} from 'models/ShareCartResponse';
import {DeliveryWebResponse} from 'models/DeliveryWebResponse';

type AddressInfoRequest = {number: string; customerType: CustomerType;};
type DiscountRequest = {code: string; pin: string;};

export const routeGetHandlePpiAgreements = (ppiIds: string) => `/api/checkout/ppi?ppiIds=${encodeURIComponent(ppiIds)}`;
export function getHandlePpiAgreements(ppiIds: string): Promise<Response> {
  return Service.get<Response>({
    url: routeGetHandlePpiAgreements(ppiIds)
  });
}

export const routeGetSalePolicy = () => `/api/checkout/salespolicy`;
export function getSalePolicy(): Promise<PolicyInformation[]> {
  return Service.get<PolicyInformation[]>({
    url: routeGetSalePolicy()
  });
}

export const routeGetIntegrityPolicy = () => `/api/checkout/integritypolicy`;
export function getIntegrityPolicy(): Promise<PolicyInformation> {
  return Service.get<PolicyInformation>({
    url: routeGetIntegrityPolicy()
  });
}

export const routePatchUpdate = () => `/api/checkout`;
export function patchUpdate(request: UpdateRequest): Promise<CheckoutPageModel> {
  return Service.patch<CheckoutPageModel>({
    url: routePatchUpdate(),
    body: request
  });
}

export const routePostGetAddressInfo = () => `/api/checkout/addressinfo`;
export function postGetAddressInfo(req: AddressInfoRequest): Promise<AddressInfo[]> {
  return Service.post<AddressInfo[]>({
    url: routePostGetAddressInfo(),
    body: req
  });
}

export const routePostDiscount = () => `/api/checkout/discount`;
export function postDiscount(req: DiscountRequest): Promise<DiscountResponse> {
  return Service.post<DiscountResponse>({
    url: routePostDiscount(),
    body: req
  });
}

export const routeDeleteDiscount = (code: string) => `/api/checkout/discount?code=${encodeURIComponent(code)}`;
export function deleteDiscount(code: string): Promise<DiscountResponse> {
  return Service.remove<DiscountResponse>({
    url: routeDeleteDiscount(code)
  });
}

export const routePostAddressSuggestions = (street: string) => `/api/checkout/addresssuggestions?street=${encodeURIComponent(street)}`;
export function postAddressSuggestions(street: string): Promise<SuggestedAddress[]> {
  return Service.post<SuggestedAddress[]>({
    url: routePostAddressSuggestions(street),
    body: null
  });
}

export const routePostZipcodeSuggestions = (zipcode: string) => `/api/checkout/zipcodesuggestions?zipcode=${encodeURIComponent(zipcode)}`;
export function postZipcodeSuggestions(zipcode: string): Promise<SuggestedAddress[]> {
  return Service.post<SuggestedAddress[]>({
    url: routePostZipcodeSuggestions(zipcode),
    body: null
  });
}

export const routePostValidateAddress = (street: string, zipcode: string, city: string) => `/api/checkout/validateaddress?street=${encodeURIComponent(street)}&zipcode=${encodeURIComponent(zipcode)}&city=${encodeURIComponent(city)}`;
export function postValidateAddress(street: string, zipcode: string, city: string): Promise<AddressValidationResponse> {
  return Service.post<AddressValidationResponse>({
    url: routePostValidateAddress(street, zipcode, city),
    body: null
  });
}

export const routePostSubmitPurchase = () => `/api/checkout`;
export function postSubmitPurchase(purchaseRequest: CheckoutFormData): Promise<PurchaseResponse> {
  return Service.post<PurchaseResponse>({
    url: routePostSubmitPurchase(),
    body: purchaseRequest
  });
}

export const routePostGetCartUrl = () => `/api/checkout/url`;
export function postGetCartUrl(): Promise<ShareCartResponse> {
  return Service.post<ShareCartResponse>({
    url: routePostGetCartUrl(),
    body: null
  });
}

export const routePostShareCart = (emailAddress: string) => `/api/checkout/sharecart?emailAddress=${encodeURIComponent(emailAddress)}`;
export function postShareCart(emailAddress: string): Promise<Response> {
  return Service.post<Response>({
    url: routePostShareCart(emailAddress),
    body: null
  });
}

export const routePostCreateDeliverySession = () => `/api/checkout/delivery-session`;
export function postCreateDeliverySession(): Promise<DeliveryWebResponse> {
  return Service.post<DeliveryWebResponse>({
    url: routePostCreateDeliverySession(),
    body: null
  });
}

export const routePostSetFallbackCartCharges = () => `/api/checkout/set-fallback-cart-charges`;
export function postSetFallbackCartCharges(): Promise<Response> {
  return Service.post<Response>({
    url: routePostSetFallbackCartCharges(),
    body: null
  });
}
